<template>
  <CSectionCard class="c-collapsible-card">
    <CSectionButton @click="toggle">
      <CSectionItem>
        <slot name="toggle"/>
        <CDirectionIcon :direction="open ? 'down' : 'right'"/>
      </CSectionItem>
    </CSectionButton>

    <CSectionItem v-if="$slots.body" class="u-px-4 u-py-2">
      <slot name="body"/>
    </CSectionItem>

    <transition name="slide">
      <div v-show="open" class="c-section-container">
        <slot name="content"/>
      </div>
    </transition>

    <div v-if="$slots.footer" class="c-section-container">
      <slot name="footer"/>
    </div>
  </CSectionCard>
</template>

<script setup lang="ts">
  import { useAttrs, watchEffect } from 'vue';
  import CDirectionIcon from './CDirectionIcon.vue';
  import CSectionButton from './section/CSectionButton.vue';
  import CSectionCard from './section/CSectionCard.vue';
  import CSectionItem from './section/CSectionItem.vue';

  const open = defineModel('open', { default: false });

  const attrs = useAttrs();

  watchEffect(() => setOpen(open.value));

  function toggle() {
    return setOpen(!open.value);
  }

  async function setOpen(newValue: boolean) {
    if (newValue && typeof attrs.onLoad === 'function') await attrs.onLoad();
    open.value = newValue;
  }
</script>

<style lang="scss">
  .c-collapsible-card {
    padding: 0;

    .slide-enter-active {
      transition: max-height .2s ease-in-out;
    }

    .slide-leave-active {
      transition: max-height .2s ease-in-out;
    }

    .slide-enter-to,
    .slide-leave-from {
      overflow: hidden;
      max-height: 1000px;
    }

    .slide-enter-from,
    .slide-leave-to {
      overflow: hidden;
      max-height: 0;
    }
  }

</style>